<template>
    <NavBar v-bind:pages="mainSitePages" class="nav-bar" />
    <div>
        <slot></slot>
    </div>
    <MainFooter />
</template>

<script setup lang="ts">
import { mainSitePages } from '~/client/mainSitePages';
</script>

<style scoped>
.nav-bar {
    margin-top: var(--m-large);
}

div {
    padding-bottom: calc(4 * var(--m-large));
}
</style>